import PropTypes from "prop-types";

export default PropTypes.shape({
	token: PropTypes.string,
	refreshToken: PropTypes.string,
	expiryDuration: PropTypes.number,
	expires: PropTypes.string,
	userId: PropTypes.string
});
